// AssessmentRatio.code and its state-name table (AppealAce/Services/AssessmentRatio.swift:1063-1094). Every state the
// engine reads goes through `stateCode`, as every Swift reader goes through `AssessmentRatio.code`. The table is a second
// copy of the app's, pinned entry by entry by functions/test/v2/valuationTableParity.test.ts.

import { characterCount, trimmed, uppercased } from "./format";

const STATE_NAMES: ReadonlyMap<string, string> = new Map<string, string>([
  ["AL", "Alabama"], ["AK", "Alaska"], ["AZ", "Arizona"], ["AR", "Arkansas"], ["CA", "California"],
  ["CO", "Colorado"], ["CT", "Connecticut"], ["DE", "Delaware"], ["FL", "Florida"], ["GA", "Georgia"],
  ["HI", "Hawaii"], ["ID", "Idaho"], ["IL", "Illinois"], ["IN", "Indiana"], ["IA", "Iowa"],
  ["KS", "Kansas"], ["KY", "Kentucky"], ["LA", "Louisiana"], ["ME", "Maine"], ["MD", "Maryland"],
  ["MA", "Massachusetts"], ["MI", "Michigan"], ["MN", "Minnesota"], ["MS", "Mississippi"], ["MO", "Missouri"],
  ["MT", "Montana"], ["NE", "Nebraska"], ["NV", "Nevada"], ["NH", "New Hampshire"], ["NJ", "New Jersey"],
  ["NM", "New Mexico"], ["NY", "New York"], ["NC", "North Carolina"], ["ND", "North Dakota"], ["OH", "Ohio"],
  ["OK", "Oklahoma"], ["OR", "Oregon"], ["PA", "Pennsylvania"], ["RI", "Rhode Island"], ["SC", "South Carolina"],
  ["SD", "South Dakota"], ["TN", "Tennessee"], ["TX", "Texas"], ["UT", "Utah"], ["VT", "Vermont"],
  ["VA", "Virginia"], ["WA", "Washington"], ["WV", "West Virginia"], ["WI", "Wisconsin"], ["WY", "Wyoming"],
  ["DC", "District of Columbia"],
]);

const NAME_TO_CODE: ReadonlyMap<string, string> = new Map<string, string>(
  [...STATE_NAMES].map(([code, name]): [string, string] => [uppercased(name), code]),
);

/** The name the table above gives `code`, or null for any string that is not one of its 51 codes, a two-Character string
 *  `stateCode` passes through unlisted ("ZZ") included. Read by functions/src/v2/resolve/stateGate.ts (W2.4a1). */
export function stateName(code: string): string | null {
  return STATE_NAMES.get(code) ?? null;
}

/** `AssessmentRatio.code(_:)`: trimmed and uppercased; any two-Character string is returned as a code, listed or not;
 *  otherwise a full state name maps to its code; anything else, and nil, is nil. */
export function stateCode(state: string | null): string | null {
  if (state === null) return null;
  const s = uppercased(trimmed(state));
  if (s.length === 0) return null;
  const count = characterCount(s);
  if (count === 2 && STATE_NAMES.has(s)) return s;
  if (count === 2) return s;
  return NAME_TO_CODE.get(s) ?? null;
}
